import Icon from '../components/Icon.vue'

Icon.register({
  'feather-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 0c-1.8 26.3-11.7 132.9-53.6 234.8l-106.5 53.2h81.1c-9.1 16.4-19.2 32.2-30.5 47.1l-146.8 48.9h101c-35.6 30.1-79.1 51.1-132.6 56.5-41.8 4.8-83.9 7.2-126 7.4l-57.1 57.1c-9.4 9.4-24.6 9.4-34 0s-9.4-24.6 0-33.9l259.5-259.2c6.3-6.3 6.3-16.4 0-22.6s-16.4-6.3-22.7 0l-178.9 178.7c1.2-26.8 2.9-53.6 6-80.2 25.4-249.4 389.2-284.1 441-287.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/feather-alt.js
// module id = 1320
// module chunks = 0